import React from "react";
export function QuiNavRight({ children }) {
    return React.createElement("div", { className: "qui-nav-right" }, children);
}
